import type { TranslationKey } from '../../core/i18n/translation';

/**
 * The four appointment states a customer is shown, by the server's status name. Shared by the card
 * that draws an appointment and the document that prints one, so the two cannot word a state apart.
 */
export const APPOINTMENT_STATUS_KEYS: Record<string, TranslationKey> = {
    Requested: 'portal.appointment_status.requested',
    Confirmed: 'portal.appointment_status.confirmed',
    Completed: 'portal.appointment_status.completed',
    Cancelled: 'portal.appointment_status.cancelled'
};
